import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Enhanced Cyberpunk Background - Same as LandingPage */}
    <div className="fixed inset-0 z-0">
      {/* Base gradient layers */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-purple-900/30 to-blue-900/20"></div>

      {/* Futuristic cityscape silhouette */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/60"></div>
      <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-purple-900/40 via-purple-800/20 to-transparent"></div>

      {/* Dynamic grid system */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(147,51,234,0.2)_1px,transparent_1px),linear-gradient(90deg,rgba(147,51,234,0.2)_1px,transparent_1px)] bg-[size:40px_40px] animate-pulse"></div>
        <div className="absolute inset-0 bg-[linear-gradient(rgba(59,130,246,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(59,130,246,0.1)_1px,transparent_1px)] bg-[size:80px_80px] animate-pulse" style={{animationDelay: '1s'}}></div>
      </div>

      {/* Subtle ambient orbs */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute rounded-full animate-pulse"
          style={{
            left: '20%',
            top: '20%',
            width: '200px',
            height: '200px',
            background: 'radial-gradient(circle, rgba(147, 51, 234, 0.1) 0%, rgba(147, 51, 234, 0.05) 50%, transparent 100%)',
            animationDelay: '0s',
            animationDuration: '8s',
          }}
        />
        <div
          className="absolute rounded-full animate-pulse"
          style={{
            left: '60%',
            top: '40%',
            width: '300px',
            height: '300px',
            background: 'radial-gradient(circle, rgba(59, 130, 246, 0.08) 0%, rgba(59, 130, 246, 0.03) 50%, transparent 100%)',
            animationDelay: '3s',
            animationDuration: '10s',
          }}
        />
        <div
          className="absolute rounded-full animate-pulse"
          style={{
            left: '10%',
            top: '70%',
            width: '150px',
            height: '150px',
            background: 'radial-gradient(circle, rgba(147, 51, 234, 0.06) 0%, rgba(147, 51, 234, 0.02) 50%, transparent 100%)',
            animationDelay: '6s',
            animationDuration: '7s',
          }}
        />
      </div>
    </div>
    <App />
  </React.StrictMode>,
)
